import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ProductDataSource} from "../../Model/dataProcess/productDataSource";
import {lastValueFrom} from "rxjs";
import {ManufacturerMapping} from "../../Model/dataProcess/manufacturerMapping";

@Injectable()
export class ManufacturerMappingService {
  private readonly apiUrl = 'api/ManufacturerMapping';

  constructor(private http: HttpClient) {}

  public getAllManufacturerMappingsByCatalogId(catalogId: string, customerId: string): Promise<ManufacturerMapping[]> {
    const url = `${this.apiUrl}/getManufacturerMappingsByCatalogId`;
    const params = new HttpParams().append('catalogId', catalogId).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<ManufacturerMapping[]>(url, options));
  }

  public update(model: ManufacturerMapping, customerId: string): Promise<ManufacturerMapping> {
    const url = `${this.apiUrl}/update`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<ManufacturerMapping>(url, model, options));
  }

  public delete(model: ManufacturerMapping, customerId: string): Promise<ManufacturerMapping> {
    const url = `${this.apiUrl}/delete`;
    const params = new HttpParams().append('customerId', customerId).append('id', model.id);
    const options = { params };
    return lastValueFrom(this.http.delete<ManufacturerMapping>(url, options));
  }
}
